<style lang="scss">
  @import '../resources/scss/project_inclusion_section.scss';
</style>

<script lang="ts">
  import type ProjectFinancialInclusionSection from '../api/rest/directus-cms/projects/model/ProjectFinancialInclusionSection'
  import { Darkness } from '../config/colors'

  export let section: ProjectFinancialInclusionSection
  export let color_class: string
</script>

<div class="container-xxl py-section bg-white">
  <div class="row gl-0">
    <div class="col-12 col-lg-6">
      <h1 class="mb-4 text-primary-{color_class}">
        {section.translations[0]?.title}
      </h1>
      <h4 class="mb-0 text-neutral-b">
        {@html section.translations[0]?.text}
      </h4>
    </div>
    <div class="col-12 col-lg-6">
      <img src={section.image?.fullUrl} class="img-fluid" alt="inclusion_logos" />
    </div>
  </div>
</div>
<div class="container-fluid bg-{Darkness.DARK}-{color_class}">
  <div class="row gl-0">
    <div class="col-12">
      <div class="container-xxl text-container">
        <h2 class="mb-0 text-white">
          {section.translations[0]?.final_message}
        </h2>
      </div>
    </div>
  </div>
</div>
